import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutBasicComponent } from './modules/core/components/layout-basic/layout-basic.component';
import { LayoutMainComponent } from './modules/core/components/layout-main/layout-main.component';
import { OrderPaymentStatusComponent } from './modules/orders/components/order-payment-status/order-payment-status.component';
import { OrderPreviewComponent } from './modules/orders/components/order-preview/order-preview.component';
import { OrderRequestComponent } from './modules/orders/components/order-request/order-request.component';
import { OrderComponent } from './modules/orders/components/order/order.component';
import { ReportExtendedComponent } from './modules/reports/components/report-extended/report-extended.component';
import { ReportPrimaryComponent } from './modules/reports/components/report-primary/report-primary.component';
import { ReportComponent } from './modules/reports/components/report/report.component';
import { LibraryComponent } from './modules/library/components/library/library.component';
import { ReportType } from './models/report.model';
import { ReportWrapperComponent } from './modules/reports/components/report-wrapper/report-wrapper.component';
import { PrivacyComponent } from './modules/core/components/privacy/privacy.component';
import { TermsComponent } from './modules/core/components/terms/terms.component';

const routes: Routes = [
  {
    path: '',
    title: 'mSpadek | wszystko o spadku',
    component: LayoutMainComponent,
  },
  {
    path: '',
    title: 'mSpadek | wszystko o spadku',
    component: LayoutBasicComponent,
    children: [
      {
        path: 'zamowienie',
        component: OrderComponent,
        children: [
          {
            path: 'podstawowy',
            component: OrderRequestComponent,
            data: {
              productType: ReportType.PRIMARY,
            },
          },
          {
            path: 'rozszerzony',
            component: OrderRequestComponent,
            data: {
              productType: ReportType.EXTENDED,
            },
          },
          {
            path: 'edytuj/podstawowy',
            component: OrderRequestComponent,
            data: {
              productType: ReportType.PRIMARY,
              mockData: true
            },
          },
          {
            path: 'edytuj/rozszerzony',
            component: OrderRequestComponent,
            data: {
              productType: ReportType.EXTENDED,
              mockData: true
            },
          },
          {
            path: 'podstawowy/:id',
            component: OrderRequestComponent,
            data: {
              productType: ReportType.PRIMARY,
            },
          },
          {
            path: 'rozszerzony/:id',
            component: OrderRequestComponent,
            data: {
              productType: ReportType.EXTENDED,
            },
          },
          {
            path: 'podglad/:id',
            component: OrderPreviewComponent,
          },
          {
            path: 'nowe/podstawowy',
            component: OrderPreviewComponent,
            data: {
              productType: ReportType.PRIMARY,
            },
          },
          {
            path: 'nowe/rozszerzony',
            component: OrderPreviewComponent,
            data: {
              productType: ReportType.EXTENDED,
            },
          },
          {
            path: 'status/:id',
            component: OrderPaymentStatusComponent,
          },
        ],
      },

      {
        path: 'raport',
        component: ReportWrapperComponent,
        children: [
          {
            path: 'podstawowy',
            component: ReportPrimaryComponent,
            data: {
              mockData: true,
            },
          },
          {
            path: 'rozszerzony',
            component: ReportExtendedComponent,
            data: {
              mockData: true,
            },
          },
          {
            path: 'podstawowy/:id',
            component: ReportPrimaryComponent,
            data: {
              mockData: false,
            },
          },
          {
            path: 'rozszerzony/:id',
            component: ReportExtendedComponent,
            data: {
              mockData: false,
            },
          },
          {
            path: ':id',
            component: ReportComponent,
            data: {
              mockData: false,
            },
          },

        ],
      },
      {
        path: 'raport/:id',
        component: ReportComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'mSpadek | Regulamin',
    path: 'regulamin',
    component: TermsComponent,
  },
  {
    title: 'mSpadek | Polityka Prywatności',
    path: 'polityka-prywatnosci',
    component: PrivacyComponent,
  },
  {
    title: 'mSpadek | Do Pobrania',
    path: 'do-pobrania',
    component: LibraryComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 200],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
